<template>
  <div
    class="form-item"
    :class="{
      'form-item-horizontal': layout === 'horizontal',
      'form-item-vertical': layout === 'vertical',
      'form-item-no-margin': noMargin,
      'form-item-with-error': errorMessage || required
    }"
    :style="{
      width: width
    }"
  >
    <div v-if="label" class="form-label-wrapper" :style="{ width: labelWidth + '!important' }">
      <label :for="id" class="form-label text-16191e small">
        <SvgIcon v-if="required" iconName="icon-icon_universe_required" class="text-danger me-1" />
        {{ label }}
      </label>
    </div>

    <div class="form-content">
      <slot name="before"></slot>
      <slot></slot>
      <slot name="after"></slot>

      <div v-if="helpText" class="form-text">
        {{ helpText }}
      </div>

      <div v-if="errorMessage" class="form-error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  width: {
    type: String,
    default: undefined
  },
  label: {
    type: String,
    default: ''
  },
  labelWidth: {
    type: String,
    default: undefined
  },
  required: {
    type: Boolean,
    default: false
  },
  layout: {
    type: String,
    default: 'vertical',
    validator: value => ['horizontal', 'vertical'].includes(value)
  },
  errorMessage: {
    type: String,
    default: ''
  },
  helpText: {
    type: String,
    default: ''
  },
  noMargin: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped>
.form-item {
  margin-bottom: 1rem;
}

.form-item-no-margin {
  margin-bottom: 0;
}

.form-item .form-item {
  margin-bottom: 0;
}

.form-item-horizontal {
  display: flex;
}

.form-item-vertical {
  display: flex;
  flex-direction: column;
}

.form-item-horizontal .form-label-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 0;
  margin-right: 0.5rem;
}

.form-item-horizontal .form-label {
  margin-bottom: 0;
}

.form-item-horizontal .form-content {
  flex: 1;
}

.invalid-feedback {
  color: #dc3545;
  font-size: 0.875em;
}

.form-text {
  color: #6c757d;
  font-size: 0.875em;
  margin-top: 0.25rem;
}
.form-error-message {
  color: #c62741;
  font-size: 0.75rem;
}
</style>
